var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SwipeableDrawer, Drawer, Box, Fade, useMediaQuery, useTheme, } from "@mui/material";
import { SidebarRight } from "iconsax-react";
import React, { useEffect, useState } from "react";
import { FIconButton } from "../buttons/IButton";
const FDrawer = (_a) => {
    var { open, onClose, onOpen = () => { }, header, children, bottom, disablePadding = false } = _a, rest = __rest(_a, ["open", "onClose", "onOpen", "header", "children", "bottom", "disablePadding"]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [showCloseButton, setShowCloseButton] = useState(false);
    useEffect(() => {
        let timeout;
        if (open && !isMobile) {
            timeout = setTimeout(() => {
                setShowCloseButton(true);
            }, 350);
        }
        else {
            setShowCloseButton(false);
        }
        return () => clearTimeout(timeout);
    }, [open, isMobile]);
    const drawerContent = (React.createElement(React.Fragment, null,
        isMobile && (React.createElement(Box, { sx: {
                width: 40,
                height: 4,
                borderRadius: 2,
                backgroundColor: "text.disabled",
                mx: "auto",
                my: 1,
            } })),
        header && (React.createElement(Box, { sx: {
                position: isMobile ? "static" : "sticky",
                top: 0,
                backgroundColor: "background.paper",
                zIndex: 1,
                px: 2,
                py: 1,
                borderColor: "divider",
            } }, header)),
        React.createElement(Box, { sx: { flexGrow: 1, overflowY: "auto", p: disablePadding ? 0 : { xs: 1, sm: 2 } } }, children),
        bottom && (React.createElement(Box, { sx: {
                px: { xs: 1, sm: 2 },
                py: 2,
                borderTop: "1px solid",
                borderColor: "divider",
                backgroundColor: "background.paper",
                position: "sticky",
                bottom: 0,
                zIndex: 2,
            } }, bottom))));
    return (React.createElement(React.Fragment, null,
        isMobile ? (React.createElement(SwipeableDrawer, Object.assign({ anchor: "bottom", open: open, onClose: onClose, onOpen: onOpen, disableDiscovery: false, disableSwipeToOpen: false, PaperProps: {
                sx: {
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    maxHeight: "calc(100dvh - 250px)",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                },
            } }, rest), drawerContent)) : (React.createElement(Drawer, Object.assign({ anchor: "right", open: open, 
            // hideBackdrop
            onClose: onClose, className: "custom-drawer", sx: {
                "& .MuiDrawer-paper": {
                    height: "100dvh",
                    width: { xs: "90%", sm: 500 },
                    display: "flex",
                    maxWidth: "500px",
                    flexDirection: "column",
                },
            } }, rest), drawerContent)),
        !isMobile && (React.createElement(Fade, { in: showCloseButton, timeout: 400 },
            React.createElement(Box, { sx: {
                    position: "fixed",
                    bottom: 32,
                    right: { xs: "90%", sm: "508px" },
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                } },
                React.createElement(FIconButton, { onClick: onClose, color: "inherit", title: "Close", style: {
                        background: "#FFFFFF",
                        width: 32,
                        height: 32,
                    } },
                    React.createElement(SidebarRight, { size: 20, color: "#637381" })))))));
};
export default FDrawer;
